import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import convertDateOverTime from '../../../helpers/convertDateOverTime'

class ProductionCol extends React.PureComponent {

    render() {
        const {production_time, commitment_time, productStatus} = this.props

        return (
            <div className={productStatus !== 'cancelled' ? 'notDisableCancel ProductionTime' : 'ProductionTime'}>
                {
                    (production_time !== undefined) &&
                    <div
                        className={classNames('d-print-flex flex-column', production_time > commitment_time && 'text-danger')}>
                        {(production_time > 0) && convertDateOverTime(production_time)}
                        {production_time > 0 && commitment_time > 0 && ' / '}
                        {(commitment_time > 0) && convertDateOverTime(commitment_time)}
                    </div>
                }
            </div>
        )
    }
}

ProductionCol.propTypes = {
    productStatus: PropTypes.string,
    production_time: PropTypes.number,
    commitment_time: PropTypes.number,
}

export default ProductionCol
